<template src="@/templates/StaticWelcomeEdu.html"></template>

<script>
	export default {
		name: "StaticWelcomeEdu",
		// props: ['identifier'],
		created () {
			// this.createComponent();
		},
		methods: {
			// createComponent() {
			// 	console.log(this.identifier);
			// }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/StaticWelcomeEdu.vue